import { getBrowserLang } from '@jsverse/transloco';

export const getDefaultLang = (): 'en' | 'es' =>
  (localStorage.getItem('lang') as 'en' | 'es') ?? (getBrowserLang() === 'es' ? 'es' : 'en');
